import { z } from 'zod';
/**
 * Project Timeline — Skill `project-timeline` (Paket D, Issue #66).
 *
 * Aggregierter Verlauf eines Projekts aus mehreren Quellen (AuditLog,
 * ProjectVersion, Comments, Status-Wechsel, Assignments, Kontakte).
 * Single Source of Truth für DTOs und Query-Parameter.
 */
export const timelineEventType = z.enum([
    'created',
    'updated',
    'status_change',
    'version_created',
    'comment_added',
    'assignment_change',
    'contact_change',
    'audit_other',
]);
/**
 * Query-Parameter — `types` als CSV oder repeated query (`?types=created&types=updated`).
 * `cursor` ist ein opaker String; intern aktuell ISO-Timestamp + Quelldaten.
 */
export const timelineQuery = z
    .object({
    types: z.array(timelineEventType).optional(),
    limit: z.coerce.number().int().positive().max(100).default(50),
    cursor: z.string().optional(),
})
    .strict();
